import { useState } from 'react'
import { can } from '../lib/api'
import { readValue, writeValue } from '../lib/prefs'
import { Messaging } from './Messaging'
import { GroupMessages } from './GroupMessages'
import { MessageGroups } from './MessageGroups'
import './group-messages.css'

/** THE MESSAGING TAB'S THREE DOORS (066): Conversations, Group messages,
 *  Groups. Each drawn only for the tick that loads it --
 *  `messaging.view`, `messaging.group_send`, `settings.members` -- and the
 *  bar itself only when there is more than one to choose between, so a role
 *  with conversations alone sees exactly the screen it had. The last choice
 *  is remembered in this browser. */
type Pane = 'conversations' | 'send' | 'groups'
const PREF = 'messaging.pane'

export function mayMessagingTab(): boolean {
  return can('messaging.view') || can('messaging.view_all') || can('messaging.group_send')
}

export function MessagingTab({ me, unread, onOpenCall, onRead }: {
  me: { display_name: string; organization?: { timezone?: string } }
  /** The tab badge's count, handed to the Unread button. */
  unread?: number
  onOpenCall: (incidentId: string, open: boolean) => void
  onRead: () => void
}) {
  const panes: { key: Pane; label: string; ok: boolean }[] = [
    { key: 'conversations', label: 'Conversations', ok: can('messaging.view') || can('messaging.view_all') },
    { key: 'send', label: 'Group messages', ok: can('messaging.group_send') },
    { key: 'groups', label: 'Groups', ok: can('messaging.group_send') && can('settings.members') },
  ]
  const allowed = panes.filter((p) => p.ok)
  const [pane, setPane] = useState<Pane>(() => readValue(
    PREF, allowed.map((p) => p.key), allowed[0]?.key ?? 'conversations') as Pane)
  const choose = (p: Pane) => { setPane(p); writeValue(PREF, p) }
  const shown = allowed.some((p) => p.key === pane) ? pane : allowed[0]?.key

  return (
    <div className="mt-page">
      {allowed.length > 1 && (
        <div className="mt-bar" role="tablist" aria-label="Messaging">
          {allowed.map((p) => (
            <button type="button" role="tab" key={p.key} aria-selected={shown === p.key}
                    className={shown === p.key ? 'mt-on' : ''} onClick={() => choose(p.key)}>
              {p.label}
            </button>
          ))}
        </div>
      )}
      {shown === 'conversations' && <Messaging me={me} unread={unread} onOpenCall={onOpenCall} onRead={onRead} />}
      {shown === 'send' && <GroupMessages me={me} />}
      {shown === 'groups' && <MessageGroups />}
    </div>
  )
}
